export enum PasswordLongevity {
  ONE_MONTH = 1,
  THREE_MONTHS = 3,
  SIX_MONTHS = 6,
  ONE_YEAR = 12,
  UNLIMITED = 12000,
}
